<!--联系方式组件-->
<template>
  <div style="height: 1920px;">
    <div class="container">
      <el-row>
        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
          <div>
            <h2>我们的信息</h2>
            <br>
            <h4>周一至周五 / 7:00 - 18:00</h4>
            <hr style="height:0px; border-top:1px solid #999; border-right:0px; border-bottom:0px; border-left:0px;width: 90%">
            <br>
            <h4>官方邮件 : 1960591723@qq.com</h4>
            <hr style="height:0px; border-top:1px solid #999; border-right:0px; border-bottom:0px; border-left:0px;width: 90%">
          </div>
        </el-col>
        <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
          <div>
            <h2>需要联系我们吗?</h2>
            <br>
            <h4>Clem GROUP 重视并欢迎您的反馈。请与我们联系，提出您的问题和建议。</h4>
            <div>

              <form action="">
                <div>
                  <el-input
                      placeholder="名字"
                      clearable
                      v-model="user.name"
                      prefix-icon="el-icon-s-custom"
                      style="margin-top: 10px"
                      @change="checkName"
                      :style="styleNameObj"
                      >
                  </el-input>
                </div>
                <div>
                  <el-input
                      placeholder="邮件"
                      clearable
                      v-model="user.mail"
                      prefix-icon="el-icon-message"
                      style="margin-top: 10px"
                      @change="checkMail"
                      :style="styleMailObj"
                  >
                  </el-input>
                </div>
                <div>
                  <el-input
                      placeholder="问题"
                      clearable
                      v-model="user.idea"
                      prefix-icon="el-icon-question"
                      style="margin-top: 10px"
                      @change="checkIdea"
                      :style="styleIdeaObj"
                  >
                  </el-input>
                </div>
                <div>
                  <el-input
                      type="textarea"
                      v-model="user.msg"
                      :autosize="{ minRows: 6, maxRows: 12}"
                      placeholder="  留言"
                      style="margin-top: 10px"
                      @change="checkMsg"
                      :style="styleMsgObj"
                      >
                  </el-input>
                </div>
                <div style="text-align: center;margin-top: 10px">
                  <el-button type="primary" round icon="el-icon-s-promotion" @click="send">发送</el-button>
                </div>
              </form>

            </div>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ContentAndForm",
  data(){
    return{
      user:{
        name: '',
        mail: '',
        idea: '',
        msg: ''
      },
      styleNameObj: {
        boxShadow: ''
      },
      styleMailObj: {
        boxShadow: ''
      },
      styleIdeaObj: {
        boxShadow: ''
      },
      styleMsgObj: {
        boxShadow: ''
      }
    }
  },
  methods: {
    checkName(){
      if (this.user.name !== ''){
        this.styleNameObj.boxShadow = '0 0 2px green';
        return true;
      }else {
        this.styleNameObj.boxShadow = '0 0 2px red';
        return false;
      }
    },
    checkMail(){
      const reg_email = /^\w+@\w+\.\w+$/;
      let flag = reg_email.test(this.user.mail);

      if (flag){
        this.styleMailObj.boxShadow = '0 0 2px green';
        return true;
      }else {
        this.styleMailObj.boxShadow = '0 0 2px red';
        return false;
      }
    },
    checkIdea(){
      if (this.user.idea !== ''){
        this.styleIdeaObj.boxShadow = '0 0 2px green';
        return true;
      }else {
        this.styleIdeaObj.boxShadow = '0 0 2px red';
        return false;
      }
    },
    checkMsg(){
      if (this.user.msg !== ''){
        this.styleMsgObj.boxShadow = '0 0 2px green';
        return true;
      }else {
        this.styleMsgObj.boxShadow = '0 0 2px red';
        return false;
      }
    },

    send(){
      if (this.checkName() && this.checkMail() && this.checkIdea() && this.checkMsg()){
        axios.post('http://121.40.117.227:9090/users',this.user).then(
            response => {
              if (response.data.data){
                this.$message({
                  showClose: true,
                  message: '发送成功！',
                  type: 'success'
                });
                this.styleNameObj.boxShadow = '';
                this.styleMailObj.boxShadow = '';
                this.styleIdeaObj.boxShadow = '';
                this.styleMsgObj.boxShadow = '';
                this.user.name = '';
                this.user.mail = '';
                this.user.idea = '';
                this.user.msg = '';
              }
            },
            error => {
              console.log(error.message);
            }
        )
      }else {
        console.log("返回值 错")
      }
    }

  }
}
</script>

<style scoped>
.container{

  margin-top: 50px;
  margin-bottom: 50px;
  padding: 50px;
  background-color: #ffffff;

}


</style>
